import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import * as actions from 'data/redux/actions'
import numeral from 'numeral'

import { useUser } from './use-user'
import { useAwards } from './use-awards'

export const useGame = (gameId) => {

  const dispatch = useDispatch()
  const { userId } = useUser()
  const game = useSelector(state => (state?.games || {})[gameId])
  const gameData = useSelector(state => ((state?.user?.gameData|| {})[gameId] || {}).status )
  const gameAllEvents = useSelector(state => ((state?.user?.gameData|| {})[gameId] || {}).status )

  useEffect(() => {

    if (game) return;

    refresh()

  }, [gameId])

  const refresh = () => {

    if (!gameId) return

    return dispatch(actions.getGame(userId, gameId))
    .then(() => 
      Promise.all([
        dispatch(actions.getGameStatus(userId, gameId)),
        // dispatch(actions.getGameUsers(gameId)),
        dispatch(actions.getWPUsers(gameId))
      ])
    )
  }

  const refreshGameStatus = () => {

    return dispatch(actions.getGameStatus(userId, gameId))
  }

  const getAllEvents = () => {

    return dispatch(actions.getAllEvents(gameId))
  }

  const getEventsByType = type => {

    const events = (game?.events || [])
    .filter(
      event => event.eventType === type ||
               (event.contentMaps || "").split(',').indexOf(type) > -1
    )
    .sort((a, b) => {
      if (a.eventOrder > b.eventOrder) return 1
      if (a.eventOrder < b.eventOrder) return -1
      return 0
    })

    return events
  }

  const markReadedAwards = awards => {

    return dispatch(actions.markReadedAwards(gameId, awards))
  }

  const formatKpiValue = (kpiId, kpiValue) => {

    if (!game.kpis) return kpiValue
    if (!game.kpis[kpiId]) return kpiValue

    const aggregation = game.kpis[kpiId].aggregation
    const mask = game.kpis[kpiId].mask
    const value = aggregation !== 'NONE' ? parseFloat(kpiValue) : kpiValue    
    return numeral(value).format(mask)
  }

  const getGameUsers = () => dispatch(actions.getGameUsers(gameId))
  const saveUserData = data => dispatch(actions.saveUserData(userId, { data: data }))

  return {
    loaded: game?.loaded,
    game: game?.game,
    user: game?.user,
    role: game?.user?.players ? game.user.players[0].role : undefined,
    events: (game?.events || []).reduce((list, event) => {
      list[event.eventId] = event
      return list
    }, {}),
    allevents: game?.allevents,
    kpis: game?.kpis,
    users: game?.users,
    player: game?.player,

    data: gameData,

    getEventsByType,
    getGameUsers,
    formatKpiValue,
    refresh,
    refreshGameStatus,
    saveUserData,
    markReadedAwards,
    getAllEvents
  }
}
